module.exports = __webpack_public_path__ + "static/family-at-the-beach-desktop.1f7c61f1.webp";